import FormModal from 'components/organisms/FormModal/FormModal'
import RouteConst from 'constants/RouteConst'
import SideNavEntryMapping from 'constants/SideNavEntryMapping'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import HotelInfoService from 'services/HotelInfoService'
import {isFormEnabled, isScandinavianProperty} from 'utilities/FormHelper'
import {
    hideSrpInventoryPage,
    isArrayNotEmpty,
    isCompletedHotelInfoHistory,
    isObjectEmpty,
    searchFirstObjectInList,
    searchObjectList
} from 'utilities/JSUtil'
import menuIcon from '../../../assets/images/icons/list.svg'
import * as FormConst from '../../../constants/FormConst'
import SessionConst from '../../../constants/SessionConst'
import { getSessionItem } from '../../../utilities/SessionHelper'
import ErrorBoundary from '../../atoms/ErrorBoundary/ErrorBoundary'
import FormHeader from '../../organisms/Form/FormHeader/FormHeader'
import SideNav from '../../organisms/SideNav/SideNav'
import ErrorHandler from './ErrorHandler'
import './WithFormLayout.scss'

/**
 * Wraps the provided Form Component within the common form layout. Injects onboarding status as a
 * property to the form. Includes the ErrorHandler component to handle auth and lock errors. Throws
 * an error when onboarding status cannot be retrieved thus preventing any form from being
 * accessed.
 * 
 * @param {Component} WrappedComponent the component to be wrapped as a form
 * @param {Object} form the form entry from SideNavConst
 * @returns the form component wrapped within the common form layout
 */
const withFormLayout = (WrappedComponent, form) => {

    return class WithFormLayout extends Component {
        constructor(props) {
            super(props)
            // Scroll down on form load
            window.scrollTo(0, 100)
            const user = getSessionItem(SessionConst.USER)
            const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
            const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
            const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY);
            const hideSrpInventory = hideSrpInventoryPage(hotelInfoCompletedHistory, this.props.checklist, hotelInfo.brandCode)

            // If user or hotel code or hotel info is missing, redirect to search page
            if (!user || isObjectEmpty(user) || !hotelCode || !hotelInfo) {
                this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
            }

            this.state = {
                hotelInfo: hotelInfo,
                hotelCode: hotelCode,
                hotelInfoCompletedHistory: hotelInfoCompletedHistory,
                isScandinavianProperty: isScandinavianProperty(hotelInfo),
                hideSrpInventory: hideSrpInventory,
                progress: 0,
                isLoading: true,
                loadingMessage: FormConst.MODAL_FORM_LAYOUT_TEXT
            }
        }

        /**
         * Lifecycle method that is executed when the component mounts.
         * Call the gateway to get the onboarding status, calculates the applicationprogress based
         * on the checklist. Sets the onboarding status and progress in the state. Displays the
         * error modal when there is an error.
         */
        async componentDidMount() {
            let totalCount = 0
            if (this.state.hotelCode) {
                if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
                    let checklist = this.state.hotelInfoCompletedHistory.newEntity.checklist

                    if (isArrayNotEmpty(checklist)) {
                        // calculate progress
                        totalCount = this.calculateTotalCount(checklist, checklist.length);
                        let completedCount = searchObjectList('processedFlag', 'COMPLETED', checklist).length
                        this.setState({ onboardingStatus: this.state.hotelInfoCompletedHistory.newEntity.status, progress: Math.floor(100 * completedCount / totalCount), checklist: checklist, isLoading: false })
                    } else {
                        this.setState({ onboardingStatus: this.state.hotelInfoCompletedHistory.newEntity.status, progress: 0, checklist: [], isLoading: false })
                    }
                } else {
                    await HotelInfoService.getOnboardingStatus({ hotelCode: this.state.hotelCode })
                        .then(response => {
                            let checklist = response.checklist
                            if (isArrayNotEmpty(checklist)) {
                                // calculate progress
                                totalCount = this.calculateTotalCount(checklist, checklist.length);
                                let completedCount = searchObjectList('processedFlag', 'COMPLETED', checklist).length
                                this.setState({ onboardingStatus: response.status, progress: Math.floor(100 * completedCount / totalCount), checklist: checklist, isLoading: false })
                            } else {
                                this.setState({ onboardingStatus: response.status, progress: 0, checklist: [], isLoading: false })
                            }

                        }).catch(error => {
                            // this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
                            this.setState({
                                              showErrorModal: true,
                                              loadingMessage: `Couldn't retreive onboarding application status`
                                          })
                        })
                }
            } else {
                this.setState({
                    showErrorModal: true,
                    loadingMessage: `Couldn't retreive onboarding application status`
                })
            }
        }

        calculateTotalCount(checklist, totalCount) {
            if (!this.state.isScandinavianProperty) {
                const ageTiersObject = searchFirstObjectInList('code', 'AGE_TIERS', checklist)
                totalCount = ageTiersObject ? checklist.length - 1 : totalCount
            }
            return totalCount;
        }

        render() {
            return (
                <div className='form-page'>
                    {/* SideNav for smaller screens */}
                    <Row>
                        <Col xs={12} className='d-xs-block d-lg-none mt-3 ml-1 mb-3'>
                            <button id='side-nav-toggle' type='button' data-toggle='collapse' data-target='#side-nav-small' aria-expanded='false' aria-controls='side-nav-small'>
                                <img src={menuIcon} alt='Menu' />
                            </button>
                            <div className='collapse' id='side-nav-small'>
                                <SideNav selectedFormId={form.current.id} checklist={this.state.checklist} />
                            </div>
                        </Col>
                    </Row>
                    {/* The common form layout - FormHeader on top followed by a Row with SideNav on the left, Form on the right */}
                    <FormHeader hotelInfo={this.state.hotelInfo} selectedFormId={form.current.id} checklist={this.state.checklist} selectedFormTitle={form.current.title} progress={this.state.progress} onboardingStatus={this.state.onboardingStatus} />
                    <Row>
                        <Col lg={3} className='d-none d-lg-block side-nav-col'><SideNav selectedFormId={form.current.id} checklist={this.state.checklist} /></Col>
                        <Col xs={12} lg={9} className='form-body-col'>
                            {/* Form body has the boundary for the form fields */}
                            <div className='form-body'>
                                {/* Adding an error boundary for the form in case the rendering results in an unhandled exception */}
                                <ErrorBoundary>
                                    <div className='display'>
                                        {
                                            this.state.isLoading ?
                                                <FormModal
                                                    id='form-layout-page-loading-modal'
                                                    title={FormConst.MODAL_READ_ACTION_TITLE}
                                                    hotelInfo={this.state.hotelInfo}
                                                    body={<h6>{this.state.loadingMessage}</h6>}
                                                    show={this.state.isLoading}
                                                    isLoadingIndicator />
                                                : (
                                                    isFormEnabled(form, this.state.checklist)
                                                        ? <WrappedComponent {...this.props} {...this.state} />
                                                        : <div className='text-center mt-5'>
                                                            <p>This page is not accessible until all required items with an (*) are completed on the dependency tabs. Please go back and complete the required fields in the the dependencies mentioned below before moving forward.</p>
                                                            <p>Dependencies: {form.current.dependencies.map((dependency) => SideNavEntryMapping[dependency]?.current.title || dependency).join(',')}</p>
                                                        </div>
                                                )
                                        }
                                    </div>
                                </ErrorBoundary>
                            </div>
                        </Col>
                    </Row>
                    <ErrorHandler hotelInfo={this.state.hotelInfo} showLockError={true} />
                    <FormModal
                        id='form-layout-error-modal'
                        title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                        hotelInfo={this.state.hotelInfo}
                        body={<h6>{this.state.loadingMessage}</h6>}
                        isError
                        show={this.state.showErrorModal}
                        proceed={() => this.props.history.push(RouteConst.ROUTE_HOME_PAGE)}
                        proceedName='Home Page'
                        isLoadingIndicator />
                </div>
            )
        }
    }
}

export default withFormLayout